<!-- <app-loader class="loader" [ngStyle]="{'display':displayStyles}"></app-loader> -->
<div class="body">
  <div style="position: fixed; top: 0; width: 100%; z-index: 10">
    <app-navbar></app-navbar>
  </div>
  <div style="margin-top: 12rem">
    <!-- <div class="heading-rounds-white" style="margin-bottom: 5rem;">
            <h2><i class="fa fa-circle" style="font-size: small; color: #3086F8;" aria-hidden="true"></i> <span class="headi">TIMELINE</span> <i class="fa fa-circle" style="font-size: small; color: #3086F8;" aria-hidden="true"></i></h2>
        </div> -->
    <div class="struct-heading">
      <h1>TIMELINE</h1>
    </div>
    <app-timeline></app-timeline>
  </div>

  <!-- <div class="container structure">
    <div class="struct-heading2">
      <h1>JUDGING CRITERIA</h1>
    </div>

    <div style="text-align: -webkit-center">
      <mat-accordion style="width: 90%" class="phone">
        <mat-expansion-panel #panel>
          <mat-expansion-panel-header
            (mouseenter)="openAccordion(panel)"
            (mouseclick)="closeAccordion(panel)"
          >
            <mat-panel-title> Venture Description </mat-panel-title>
          </mat-expansion-panel-header>
          <ul>
            <li>
              Problem: Summarize the problem your venture solves and how it's
              different.
            </li>
            <li>
              Stage: State your venture's current stage (concept, prototype,
              early customers)
            </li>
          </ul>
        </mat-expansion-panel>
        <mat-expansion-panel #panel2>
          <mat-expansion-panel-header
            (mouseenter)="openAccordion(panel2)"
            (mouseclick)="closeAccordion(panel2)"
          >
            <mat-panel-title> Market Analysis </mat-panel-title>
          </mat-expansion-panel-header>
          <ul>
            <li>
              Market Potential: Briefly outline the market you're entering and
              its growth potential.
            </li>
            <li>
              Challenges & Opportunities: Mention key barriers and growth
              opportunities in the market.
            </li>
          </ul>
        </mat-expansion-panel>
        <mat-expansion-panel #panel3>
          <mat-expansion-panel-header
            (mouseenter)="openAccordion(panel3)"
            (mouseclick)="closeAccordion(panel3)"
          >
            <mat-panel-title> Unique value proposition </mat-panel-title>
          </mat-expansion-panel-header>
          <ul>
            <li>
              Differentiation: Explain what sets your idea apart from existing
              solutions.
            </li>
          </ul>
        </mat-expansion-panel>
        <mat-expansion-panel #panel4>
          <mat-expansion-panel-header
            (mouseenter)="openAccordion(panel4)"
            (mouseclick)="closeAccordion(panel4)"
          >
            <mat-panel-title> Competitive landscape </mat-panel-title>
          </mat-expansion-panel-header>
          <ul>
            <li>
              Key Competitors: Identify the main competitors in your field.
            </li>
            <li>Strategy: Describe your plan to overcome the competition</li>
          </ul>
        </mat-expansion-panel>
        <mat-expansion-panel #panel5>
          <mat-expansion-panel-header
            (mouseenter)="openAccordion(panel5)"
            (mouseclick)="closeAccordion(panel5)"
          >
            <mat-panel-title> Revenue model description </mat-panel-title>
          </mat-expansion-panel-header>
          <ul>
            <li>Revenue: Outline how you'll make money.</li>
            <li>
              Projections: Highlight key costs and share short-term revenue and
              growth opportunities.
            </li>
          </ul>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

  </div> -->
  <div class="rounded">
    <!-- <div class="heading-rounds-white">
        <h2><i class="fa fa-circle" style="font-size: small; color: #3086F8;" aria-hidden="true"></i> <span class="headi">RULES</span> <i class="fa fa-circle" style="font-size: small; color: #3086F8;" aria-hidden="true"></i></h2>
    </div> -->
    <div class="struct-heading3">
      <h1>RULES</h1>
    </div>
    <div>
      <div class="tabs">
        <!-- <input type="radio" name="tabs" id="tab4" checked="checked">
            <label for="tab4" style="  border-radius: 1.5rem 0px 0px 1.5rem;">GENERAL RULES</label>
            <input type="radio" name="tabs" id="tab5">
            <label for="tab5">PAN IIT RULES</label>
            <input type="radio" name="tabs" id="tab6">
            <label for="tab6" style="  border-radius: 0rem 1.5rem 1.5rem 0rem;">QUESTIONNAIRE RULES</label> -->

        <input type="radio" name="tabs" id="tab7" checked="checked" />
        <label for="tab7">GENERAL RULES</label>
        <i
          class="fa fa-square"
          style="font-size: small; color: #3086f8"
          aria-hidden="true"
        ></i>
        <input type="radio" name="tabs" id="tab5" />
        <!-- <label for="tab5">PAN IIT RULES</label> -->
        <!-- <i
          class="fa fa-square"
          style="font-size: small; color: #3086f8"
          aria-hidden="true"
        ></i> -->
        <input type="radio" name="tabs" id="tab6" />
        <label for="tab6">QUESTIONNAIRE & MENTORSHIP RULES</label>

        <div class="tab-content-wrapper">
          <div id="tab-content-7" class="tab-content">
            <div class="card-2">
              <div class="ace-2">
                <ul *ngFor="let lis of list">
                  <li>
                    <p>{{ lis.guideline }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div id="tab-content-5" class="tab-content">
            <div class="card-2">
              <div class="ace-2">
                <ul *ngFor="let lis of lis">
                  <li>
                    <p>{{ lis.guideline }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div id="tab-content-6" class="tab-content">
            <div class="card-2">
              <div class="ace-2">
                <ul *ngFor="let lis of lift">
                  <li>
                    <p>{{ lis.guideline }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div>
    <h1 class="col-10">FAQs</h1>

    <mat-accordion style="width: 90%;" *ngFor="let lis of faqlist" >
    <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{lis.ques}}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p>{{lis.ans}}</p>
        <p><a href="{{lis.link}}">{{lis.link}}</a></p>
      </mat-expansion-panel>
      </mat-accordion>
</div> -->

  <div class="backg">
    <!-- <div class="inverse-border">

    </div> -->
    <app-footer></app-footer>
  </div>
</div>
